import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './PartnerwiseReport.css';

const PartnerwiseReport = () => {
  const [partners, setPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState('');
  const [reportData, setReportData] = useState([]);
  const navigate = useNavigate(); // Hook to navigate

  // Fetch partners on component mount
  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/partners`);
        setPartners(response.data);
      } catch (error) {
        console.error('Error loading partner data:', error);
        alert('Failed to load partner data.');
      }
    };

    fetchPartners();
  }, []);

  // Fetch loan report data based on selected partner
  const fetchReportData = async (partner) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/loans-by-partner/${partner}`
      );
      setReportData(response.data);
    } catch (error) {
      console.error('Error fetching report data:', error);
      alert('Failed to load report data.');
    }
  };

  // Handle partner selection change
  const handlePartnerChange = (e) => {
    const partner = e.target.value;
    setSelectedPartner(partner);
    fetchReportData(partner);
  };

  // Handle back button click
  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  return (
    <div className="partnerwise-report-container">
      {/* Back Button */}
      <button onClick={handleBackClick} className="back-button">
        Back
      </button>

      <h2>Partnerwise Loan Report</h2>

      <div className="input-group">
        <label htmlFor="partner">Partner Name:</label>
        <select
          id="partner"
          value={selectedPartner}
          onChange={handlePartnerChange}
        >
          <option value="">Select Partner</option>
          {partners.map((partner, index) => (
            <option key={index} value={partner}>
              {partner}
            </option>
          ))}
        </select>
      </div>

      {reportData.length > 0 && (
        <table className="report-table">
          <thead>
            <tr>
              <th>Account Number</th>
              <th>Name</th>
              <th>Date</th>
              <th>Loan Amount</th>
              <th>Period (Days)</th>
            </tr>
          </thead>
          <tbody>
            {reportData.map((loan) => (
              <tr key={loan.account_no}>
                <td>{loan.account_no}</td>
                <td>{loan.loanee_name}</td>
                <td>{new Date(loan.date).toLocaleDateString()}</td>
                <td>{loan.loan_amount}</td>
                <td>{loan.period}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
export default PartnerwiseReport;
